module.exports = __webpack_public_path__ + "img/apps.b79050fc.png";